<template>
  <div class="work_order_box">
    <div class="order_info">
      <span>贵司订单号：{{ orderInfo.channelOrderNum }}</span>
      <span>|</span>
      <span>科坦订单号：{{ orderInfo.outerOrderId }}</span>
    </div>

    <div class="work_order_form">
      <div class="form_item">
        <span class="title required">是否到店：</span>
        <el-radio-group v-model="workOrderForm.reachType">
          <el-radio :label="1">未到店</el-radio>
          <el-radio :label="2">已到店</el-radio>
          <el-radio :label="3">已离店</el-radio>
        </el-radio-group>
      </div>
      <div class="form_item">
        <span class="title required">工单类型：</span>
        <div>
          <el-select v-model="workOrderForm.typeId" size="mini" placeholder="请选择工单类型" style="width: 280px;"
            :disabled="isSelType">
            <el-option v-for="item in workOrderTypes" :key="item.typeId" :value="item.typeId" :label="item.typeName"
              v-show="!processingSubTypeIds.includes(item.typeId)"></el-option>
          </el-select>
          <p style="margin-top: 10px;color: #aaaab2;">相同工单类型的工单需已完成后才能再次创建</p>
        </div>
      </div>
      <div v-if="workOrderForm.typeId === 11 && hotelConfirmationNumber">
        <div style="margin-bottom: 25px;text-align: center">
          <img src="@/assets/newImage/warning.png" alt="" style="margin-bottom: 15px"/>
          <div>
            <span>订单已有确认号：</span>
            <span style="color: #1b48d8">{{ hotelConfirmationNumber }}</span>
          </div>
        </div>
        <div style="text-align: center;margin-bottom: 20px">
          <el-button type="primary" style="width: 50%;border-radius: 50px" @click="closeDialog">我知道了</el-button>
        </div>
      </div>
      <div v-else>
        <div class="form_item">
          <span class="title">工单内容：</span>
          <el-input type="textarea" :rows="4" placeholder="请输入工单内容" v-model="workOrderForm.issueDesc"
                    style="width: 560px;" :maxlength="500" show-word-limit>
          </el-input>
        </div>
        <div class="form_item">
          <span class="title">上传附件：</span>
          <el-upload action="#" :limit="9" accept="*"
                     :auto-upload="false" :on-exceed="handleExceed" :file-list="fileList" :on-change="fileChange"
                     :on-remove="fileRemove">
            <el-button size="small" icon="el-icon-upload2">上传文件</el-button>
          </el-upload>
        </div>
<!--        <div class="form_item">-->
<!--          <span class="title"></span>-->
<!--          <p style="font-size: 14px;color: #aaaab2;">当前只支持上传图片，其他文件请通过邮件形式发送。</p>-->
<!--        </div>-->
      </div>
    </div>
    <div class="work_order_btn" v-if="!(workOrderForm.typeId === 11 && hotelConfirmationNumber)">
      <el-button @click="closeDialog" round size="medium">取 消</el-button>
      <el-button type="primary" @click="toAddWorkOrder" round size="medium">提 交</el-button>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    orderInfo: {
      type: Object,
      default: () => { }
    },
    showAddWorkOrderDialog: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      partnerInfo: {},
      workOrderTypes: [],
      workOrderForm: {},
      fileList: [],
      isSelType: false,
      processingSubTypeIds: [],
      hotelConfirmationNumber: ''
    }
  },
  created () {
    this.partnerInfo = JSON.parse(this.$common.isLogin())
    this.getWorkOrderTypes()
  },
  watch: {
    showAddWorkOrderDialog: {
      async handler (val) {
        if (val) {
          await this.showAddWorkOrder()
          await this.searchOrderByOuterId()
        } else {
          this.hotelConfirmationNumber = ''
          this.workOrderForm = {}
          this.fileList = []
        }
      },
      immediate: true
    }
  },
  methods: {
    async getWorkOrderTypes () {
      const { data: result } = await this.$http.get('/work_order_api/2.0/workOrderTypes')
      if (result.resultCode != 0) return this.$message.error("网络错误，请稍后再试")
      this.workOrderTypes = result.workOrderTypes
    },
    async searchOrderByOuterId () {
      let reqHeaders = {
        headers: {
          accessToken: this.partnerInfo.token
        }
      }
      const { data: result } = await this.$http.get(`/mini/searchOrderByOuterId?outerOrderId=${this.orderInfo.outerOrderId}`, reqHeaders)
      if (result.code !== 200) return
      this.hotelConfirmationNumber = result.data[0] && result.data[0].hotelConfirmationNumber ? result.data[0].hotelConfirmationNumber : ''
    },
    async showAddWorkOrder () {
      if (!this.partnerInfo.partnerCode) {
        this.partnerInfo = JSON.parse(this.$common.isLogin())
      }
      this.$set(this.workOrderForm, 'orderId', this.orderInfo.outerOrderId)
      let name = this.partnerInfo.personType == 1 ? this.partnerInfo.name : this.partnerInfo.accountName
      this.$set(this.workOrderForm, 'creator', `${name}(${this.partnerInfo.companyName})`)
      this.$set(this.workOrderForm, 'reachType', this.getReachType(this.orderInfo.checkIn))
      if (this.orderInfo.orderStatus == 3 || this.orderInfo.orderStatus == 15) {
        this.$set(this.workOrderForm, 'typeId', 9)
        this.isSelType = true
      } else {
        this.isSelType = false
      }
      this.processingSubTypeIds = []
      const { data: result } = await this.$http.get(`/mini/searchProcessingWorkOrders?orderId=${this.orderInfo.outerOrderId}`, { headers: { accessToken: this.partnerInfo.token } })
      if (result.code == 200) {
        this.processingSubTypeIds = result.data
      }
    },
    getReachType (checkIn) {
      if (!checkIn) return 0
      let nowDate = new Date().Format('yyyy-MM-dd');
      if (nowDate < checkIn) {
        return 1
      } else if (nowDate == checkIn) {
        return 2
      } else {
        return 3
      }
    },
    closeDialog (isCommit) {
      this.$emit('closeDialog', isCommit)
      this.workOrderForm = {}
      this.hotelConfirmationNumber = ''
      this.fileList = []
    },
    handleExceed () {
      this.$message.warning('仅允许上传9张图片')
    },
    fileChange (file, fileList) {
      this.fileList = fileList
    },
    fileRemove (file, fileList) {
      this.fileList = fileList
    },
    async toAddWorkOrder () {
      if (!this.workOrderForm.reachType || !this.workOrderForm.typeId) {
        return this.$message.warning('请填写完整信息')
      }
      if (this.workOrderForm.typeId !== 1 && this.workOrderForm.typeId !== 11) {
        if (!this.workOrderForm.issueDesc) return this.$message.warning('请输入工单内容')
      }
      if (this.fileList.length) {
        let imgUrl = await this.uploadImage()
        if (imgUrl && imgUrl.length) {
          this.workOrderForm.attachments = imgUrl
        }
      }
      this.doAddWorkOrder()
    },
    async doAddWorkOrder () {
      let reqHeader = {
        partnerCode: this.partnerInfo.partnerCode.toString()
      }
      const { data: result } = await this.$http.post('/work_order_api/2.0/createWorkOrder', this.workOrderForm, { headers: reqHeader })
      if (result.resultCode != 0) return this.$message.error(result.detailError)
      this.$message.success('提交成功')
      this.closeDialog(true)
      if (this.type == 'orderList') {
        let orderInfo = { ...this.orderInfo }
        orderInfo.newWorkOrderId = result.workOrderId
        setTimeout(() => {
          this.$emit('toDetail', orderInfo)
        }, 500);
      }
    },
    async uploadImage () {
      let formData = new FormData()
      formData.append('outerOrderId', this.orderInfo.outerOrderId)
      this.fileList.forEach(file => {
        formData.append('file', file.raw)
      })
      const { data: result } = await this.$http.post('/mini/uploadAttachments', formData, { headers: { accessToken: this.partnerInfo.token } })
      if (result.code != 200) return this.$message.error(result.message)
      return result.data
    }
  }
}
</script>

<style lang="less" scoped>
.work_order_box {
  border-top: 1px solid #eaeaea;
  padding-top: 10px;
  color: #272727;

  .order_info {
    font-size: 13px;
    background: #f2f2f2;
    padding: 10px 2px;
  }

  .work_order_form {
    margin-top: 20px;
    padding-left: 20px;

    .form_item {
      display: flex;

      margin-bottom: 25px;

      .title {
        width: 90px;

        &.required::before {
          content: '*';
          color: red;
        }
      }

      /deep/ .el-upload--picture-card {
        width: 100px;
        height: 100px;
        line-height: 100px;
      }

      /deep/ .el-upload-list--picture-card .el-upload-list__item {
        width: 100px;
        height: 100px;
      }
    }
  }

  .work_order_btn {
    text-align: right;
    padding: 15px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/newPages/order/components/AddWorkOrder.vue